
import AppIcon from './AppIcon.vue';

export default {
  name: 'AppList',
  props: {
    list: {
      type: Array,
      default: undefined,
      required: false,
    },
    horizontalGap: {
      type: String,
      default: 'medium',
    },
  },
  components: {
    AppIcon,
  },
};
